var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLikeDislike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.10156 16.9001L5.57657 18.0418C5.76823 18.2335 6.19323 18.3251 6.4849 18.3251H8.29323C8.86823 18.3251 9.4849 17.9002 9.62657 17.3252L10.7682 13.8501C11.0099 13.1835 10.5766 12.6085 9.8599 12.6085H7.95156C7.66823 12.6085 7.42656 12.3667 7.47656 12.0334L7.71823 10.5084C7.8099 10.0834 7.52656 9.6001 7.10156 9.45844C6.71823 9.31677 6.24323 9.50846 6.05157 9.79179L4.10156 12.7001",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.66797 16.9002V12.2335C1.66797 11.5669 1.9513 11.3251 2.61797 11.3251H3.09297C3.75963 11.3251 4.04297 11.5669 4.04297 12.2335V16.9002C4.04297 17.5669 3.75963 17.8085 3.09297 17.8085H2.61797C1.9513 17.8085 1.66797 17.5752 1.66797 16.9002Z",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.902 3.10008L14.427 1.95841C14.2353 1.76675 13.8103 1.67511 13.5186 1.67511H11.7103C11.1353 1.67511 10.5186 2.10007 10.377 2.67507L9.2353 6.15011C8.99364 6.81677 9.42697 7.39176 10.1436 7.39176H12.052C12.3353 7.39176 12.577 7.63348 12.527 7.96682L12.2853 9.49178C12.1936 9.91678 12.477 10.4001 12.902 10.5418C13.2853 10.6835 13.7603 10.4918 13.952 10.2084L15.902 7.30011",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3359 3.10008V7.76672C18.3359 8.43339 18.0526 8.67513 17.3859 8.67513H16.9109C16.2443 8.67513 15.9609 8.43339 15.9609 7.76672V3.10008C15.9609 2.43341 16.2443 2.19177 16.9109 2.19177H17.3859C18.0526 2.19177 18.3359 2.42508 18.3359 3.10008Z",
    stroke: "#0E1111",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLikeDislike);
export default __webpack_public_path__ + "static/media/like-dislike.70c25629bee66ad060ea94ca1d4cc029.svg";
export { ForwardRef as ReactComponent };